import React, { useState, useEffect } from 'react';
import Select from 'react-select';

const CTDropdown = (props) => {
  const { data, handleChange, placeholder,value } = props;
  const [options, setOptions] = useState([]);
  useEffect(() => {
    // Map data to options
    console.log(data, "data in dropdown")
    if (data && Array.isArray(data)) {
      const mappedOptions = data.map((item,index) => ({
        value: item.id ==0?index : item.id, // Use 'value' for react-select
        label: item.name,
      }));
      setOptions(mappedOptions);
    }
  }, [data]);



  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '40px',
      borderRadius: '6px',
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: '#e2e8f0',
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: '#1a202c',
      fontWeight: 500,
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      ':hover': {
        backgroundColor: '#c53030',
        color: 'white',
      },
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? 'var(--pmr-primary)' : isFocused ? '#cbd5e0' : null,
      color: isSelected ? 'white' : isFocused ? 'black' : '#1a202c',
      fontWeight: isSelected ? 'bold' : 'normal',
      padding: 10,
    }),
    menu: (styles) => ({
      ...styles,
      zIndex: 9999,
    }),
    placeholder: (styles) => ({
      ...styles,
      color: '#999',
      fontWeight: 'bold',
      fontSize: '14px',
    }),
  };

  return (
    <Select
      className='mb-3'
      options={options}
      value={value}
      onChange={handleChange}
      isMulti={true}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      isSearchable={true}
      styles={customStyles}
      placeholder={placeholder}
    />
  );
};

export default CTDropdown;